import { postClickStatistics } from "~/services/common";
import { type PostClickStatistics } from "~/services/model/index-click-statistics";

export function trackEvent(type: PostClickStatistics['type']) {
    return postClickStatistics({
        type
    })
}